import type { RequestOptions } from '@cravo/core'
import { api } from '../api-client'

export interface SessionInfo {
  id: string
  deviceId: string | null
  platform: string | null
  fcmToken: string | null
  lastActiveAt: string
  createdAt: string
}

export interface SessionsResponse {
  message: string
  sessions: SessionInfo[]
  total: number
}

export const sessionsApi = {
  list(options?: RequestOptions): Promise<SessionsResponse> {
    return api.get<SessionsResponse>('/sessions', options)
  },

  registerFcmToken(
    body: { token: string; platform: 'web' | 'ios' | 'android'; deviceId: string },
    options?: RequestOptions,
  ): Promise<{ message: string }> {
    return api.post<{ message: string }>('/sessions/fcm', body, options)
  },

  deregisterFcmToken(
    body: { token: string; platform: 'web' | 'ios' | 'android' },
    options?: RequestOptions,
  ): Promise<{ message: string; cleared: number }> {
    return api.post<{ message: string; cleared: number }>('/sessions/fcm/deregister', body, options)
  },

  deleteSession(sessionId: string, options?: RequestOptions): Promise<{ message: string }> {
    return api.delete<{ message: string }>(`/sessions/${sessionId}`, options)
  },

  deleteAllSessions(
    params?: { excludeDeviceId?: string },
    options?: RequestOptions,
  ): Promise<{ message: string }> {
    return api.delete<{ message: string }>('/sessions', {
      ...options,
      params: { excludeDeviceId: params?.excludeDeviceId, ...options?.params },
    })
  },
}
